import { useState, useEffect } from "react";
import {
    handleAsync,
    getMyImages,
    handleGetPdfDetails,
    checkName,
    checkNameSurvey,
    checkPledgeName,
    checkRegisteredMember,
} from "../utils/api";
import { isRegistrationSurveyName } from "../utils/templateWords";
import { extractData } from "../utils/functions";

export const usePaylinkData = (trackCode, urlOption, urlAmount, code) => {
    const [data, setData] = useState();
    const [load, setLoad] = useState(false);
    const [amount, setAmount] = useState(0.0);
    const [isApiAmount, setIsApiAmount] = useState(false);
    const [number, setNumber] = useState();
    const [phoneLength, setPhoneLength] = useState(10);
    const [name, setName] = useState();
    const [image, setImage] = useState();
    const [buttone, setButtone] = useState();
    const [nameOption, setNameOption] = useState();
    const [paymentData, setPaymentData] = useState();
    const [payLink, setPayLink] = useState();
    const [subActive, setSubActive] = useState(true);
    const [saleId, setSaleId] = useState();
    const [subscribeData, setSubscribeData] = useState();
    const [memberPay, setMemberPay] = useState();
    const [defaultOptions, setDefaultOptions] = useState([]);
    const [urlOptions, setUrlOptions] = useState([]);
    const [payAccountDetails, setPayAccountDetails] = useState(null);
    const [selection, setSelection] = useState();

    const [type, setType] = useState("");
    const [org_id, setOrgId] = useState("");
    const [sales_code, setSalesCode] = useState("");
    const [paylink_id, setPayLinkId] = useState("");
    const [original_date, setOriginalDate] = useState("");

    const [imgUri, setImgUri] = useState();

    const [docImageUrl, setDocImageUrl] = useState();
    const [docTemplate, setDocTemplate] = useState();
    const [docHexCode, setDocHexCode] = useState();
    const [docTermsService, setDocTermsService] = useState("default");
    const [loadDocs, setLoadDocs] = useState(true);

    const [disabled, setDisabled] = useState(false);
    const [contactId, setContactId] = useState();
    const [customerName, setCustomerName] = useState();
    const [isRegisteredMember, setIsRegisteredMember] = useState(false);
    const [isRegisteredPledgeMember, setIsRegisteredPledgeMember] = useState(false);

    const [survey, setSurvey] = useState(false);
    const [reqSurveyId, setReqSurveyId] = useState();
    const [pledgeNumber, setPledgeNumber] = useState();
    const [pledgeAmount, setPledgeAmount] = useState();
    const [triggerSurvey, setTriggerSurvey] = useState(false);
    const [requestId, setRequestId] = useState("");

    const dataSale = data?.data?.saledata;
    const sale_to = dataSale?.sale_to;
    const registeredOnlySetting =
        dataSale?.sale_settings?.registered_only === true ||
        dataSale?.sale_settings?.registered_only === 1 ||
        dataSale?.sale_settings?.registered_only === "true";
    // Surveys/forms whose name contains "register" (e.g. a registration form)
    // must stay open to new contacts, so they ignore the registered_only setting.
    const activeSurveyName =
        data?.data?.all_surveys?.find((s) => s.id === reqSurveyId)?.survey_name || "";
    const isRegistrationSurvey =
        survey && isRegistrationSurveyName(activeSurveyName);
    const registeredOnly = registeredOnlySetting && !isRegistrationSurvey;

    useEffect(() => {
        const fetchData = async () => {
            if (!trackCode) return;

            setLoad(true);

            try {
                const result = await handleAsync(code, urlOption, urlAmount);

                setData(result.data);
                setAmount(result.amount);
                setNumber(result.number);
                setPhoneLength(result.phoneLength);
                setName(result.name);
                setImage(result.image);
                setButtone(result.buttone);
                setNameOption(result.nameOption);
                setPaymentData(result.paymentData);
                setPayLink(result.payLink);
                setSubActive(result.subActive);
                setSaleId(result.saleId);
                setSubscribeData(result.subscribeData);
                setMemberPay(result.memberPay);
                setDefaultOptions(result.defaultOptions);
                setUrlOptions(result.urlOptions);
                setPayAccountDetails(result.payAccountDetails);
                setSelection(result.selection);
                setIsApiAmount(result.isApiAmount);

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoad(false);
            }
        };

        fetchData();
    }, [trackCode, code, urlOption, urlAmount]);

    useEffect(() => {
        if (dataSale && data) {
            const { type, org_id, sales_code, paylink_id, original_date } =
                extractData(dataSale, data);
            setType(type);
            setOrgId(org_id);
            setSalesCode(sales_code);
            setPayLinkId(paylink_id);
            setOriginalDate(original_date);
        }
    }, [dataSale, data]);

    useEffect(() => {
        const fetchImages = async () => {
            if (org_id) {
                try {
                    const uri = await getMyImages(org_id);
                    setImgUri(uri);
                } catch (error) {
                    console.error(error);
                }
            }
        };
        fetchImages();
    }, [org_id]);

    useEffect(() => {
        const fetchPdfDetails = async () => {
            if (org_id) {
                setLoadDocs(true);
                try {
                    const result = await handleGetPdfDetails(org_id);
                    setDocImageUrl(result.docImageUrl);
                    setDocTemplate(result.docTemplate);
                    setDocHexCode(result.docHexCode);
                    setDocTermsService(result.docTermsService);
                } catch (error) {
                    console.error(error);
                } finally {
                    setLoadDocs(false);
                }
            }
        };
        fetchPdfDetails();
    }, [org_id]);

    useEffect(() => {
        const fetchName = async () => {
            if (
                !registeredOnly &&
                org_id &&
                (type === "Collection" || type === "Wallet") &&
                !survey &&
                number?.length === phoneLength
            ) {
                setDisabled(true);
                try {
                    const result = await checkName(org_id, number, nameOption);
                    setName(result);
                } catch (error) {
                    console.error(error);
                } finally {
                    setDisabled(false);
                }
            }
        };
        fetchName();
    }, [number, org_id, type, survey, phoneLength, nameOption, registeredOnly]);

    useEffect(() => {
        const fetchNameSurvey = async () => {
            if (
                !registeredOnly &&
                org_id &&
                (type === "Collection" || type === "Wallet") &&
                survey &&
                number?.length === phoneLength
            ) {
                setContactId("");
                setName("");
                setDisabled(true);
                try {
                    const result = await checkNameSurvey(org_id, number);
                    setName(result.name);
                    setContactId(result.contactId);
                } catch (error) {
                    console.error(error);
                } finally {
                    setDisabled(false);
                }
            }
        };
        fetchNameSurvey();
    }, [number, org_id, type, survey, phoneLength, registeredOnly]);

    // registered_only: the phone number field can hold either a phone number
    // (fixed target length, checked as soon as it's reached) or free text like
    // an email (no fixed length, so we debounce after typing pauses instead).
    // Covers both the main pay form and the survey form, which share `number`.
    useEffect(() => {
        if (
            !registeredOnly ||
            !org_id ||
            !(type === "Collection" || type === "Wallet")
        ) {
            return;
        }

        const value = (number || "").trim();
        const isPhoneLike = /^\d+$/.test(value);
        const isReady = isPhoneLike ? value.length === phoneLength : value.length >= 4;

        if (!isReady) {
            setIsRegisteredMember(false);
            if (survey) setContactId("");
            return;
        }

        let cancelled = false;
        setIsRegisteredMember(false);
        if (survey) setContactId("");
        setDisabled(true);

        const run = async () => {
            try {
                const result = await checkRegisteredMember(sale_to, value);
                if (cancelled) return;
                setIsRegisteredMember(result.found);
                setName(
                    result.found ? result.name || (!nameOption ? "anonymous" : "") : ""
                );
                if (survey) setContactId(result.found ? result.contactId : "");
            } catch (error) {
                if (!cancelled) {
                    console.error(error);
                    setIsRegisteredMember(false);
                }
            } finally {
                if (!cancelled) setDisabled(false);
            }
        };

        const handle = setTimeout(run, isPhoneLike ? 0 : 600);
        return () => {
            cancelled = true;
            clearTimeout(handle);
        };
    }, [number, org_id, type, survey, phoneLength, nameOption, registeredOnly, sale_to]);

    useEffect(() => {
        const fetchPledgeName = async () => {
            if (
                !registeredOnly &&
                org_id &&
                (type === "Collection" || type === "Wallet") &&
                pledgeNumber?.length === phoneLength
            ) {
                setDisabled(true);
                try {
                    const result = await checkPledgeName(org_id, pledgeNumber);
                    setCustomerName(result);
                } catch (error) {
                    console.error(error);
                } finally {
                    setDisabled(false);
                }
            }
        };
        fetchPledgeName();
    }, [pledgeNumber, org_id, type, phoneLength, registeredOnly]);

    // registered_only for pledges: pledgeNumber is always a phone number (no
    // email mode), so the exact-length trigger used elsewhere in this hook
    // for phone input is sufficient here.
    useEffect(() => {
        if (
            !registeredOnly ||
            !org_id ||
            !(type === "Collection" || type === "Wallet") ||
            pledgeNumber?.length !== phoneLength
        ) {
            setIsRegisteredPledgeMember(false);
            return;
        }

        let cancelled = false;
        setIsRegisteredPledgeMember(false);
        setDisabled(true);

        const run = async () => {
            try {
                const result = await checkRegisteredMember(sale_to, pledgeNumber);
                if (cancelled) return;
                setIsRegisteredPledgeMember(result.found);
                setCustomerName(result.found ? result.name : "");
            } catch (error) {
                if (!cancelled) {
                    console.error(error);
                    setIsRegisteredPledgeMember(false);
                }
            } finally {
                if (!cancelled) setDisabled(false);
            }
        };

        run();
        return () => {
            cancelled = true;
        };
    }, [pledgeNumber, org_id, type, phoneLength, registeredOnly, sale_to]);

    return {
        data,
        load,
        amount,
        setAmount,
        number,
        setNumber,
        phoneLength,
        setPhoneLength,
        name,
        setName,
        image,
        buttone,
        nameOption,
        paymentData,
        payLink,
        subActive,
        saleId,
        subscribeData,
        memberPay,
        defaultOptions,
        urlOptions,
        payAccountDetails,
        selection,
        setSelection,
        type,
        org_id,
        sales_code,
        paylink_id,
        original_date,
        imgUri,
        docImageUrl,
        docTemplate,
        docHexCode,
        docTermsService,
        loadDocs,
        disabled,
        contactId,
        setContactId,
        customerName,
        setCustomerName,
        isRegisteredMember,
        isRegisteredPledgeMember,
        registeredOnly,
        dataSale,
        survey,
        setSurvey,
        reqSurveyId,
        setReqSurveyId,
        pledgeNumber,
        setPledgeNumber,
        pledgeAmount,
        setPledgeAmount,
        triggerSurvey,
        setTriggerSurvey,
        requestId,
        setRequestId,
        isApiAmount
    };
};
